import { Table } from 'antd';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTimesheet } from '../../hooks';
import { getColumns } from '../../utils';
import { nonEditableTimesheetCols } from './non-editable-timesheet.columns';
import { Commentwaitingproject } from '../line-manager-comment/comment-waiting-Project/comment-waiting-project';
import { COUNTRY_VALUE } from '../timesheet-timeline/constants';

export const NonEditableTimesheet = ({ loading, timesheetEntries, tableTitle }) => {
  
  const { days } = useSelector((state) => state.timesheet);
  const { weekInfo, setTimesheetValues, timesheet, pdCommentShown } = useTimesheet();
  const Timesheet_Status=useSelector((state)=>state.employees.TimesheetStatus)
  const Find_country=useSelector((state)=>state.appConfiguration.entityCode)
  useEffect(() => {
    setTimesheetValues(timesheet);
  }, [timesheet]);
    const waitingLineManagercomment = timesheet?.timeSheetEntryPerActivities;
  
  return (
    <>
    <Table
      loading={loading}
      dataSource={timesheetEntries}
      columns={getColumns(nonEditableTimesheetCols, {
        days: days?.days,
        editable: false,
        weekInfo,
        pdCommentShown,
        values: timesheet,
        Timesheet_Status
      })}
      rowKey="id"
      pagination={false}
      title={() => tableTitle}
    />
    {waitingLineManagercomment&&Find_country==COUNTRY_VALUE.INDIA?<Commentwaitingproject waitingLineManagercomment={waitingLineManagercomment} tableTitle={tableTitle}/>:[]}
    </>
  );
};
